export const PATIENT_REMARK = '/patients/save-note'
export const getProvidersAssociatedToPatient = (patientId: string): string =>
  `/patients/associated-providers?patientId=${patientId}`
export const uploadPatientDocumentRoute = (patientId: string): string =>
  `patients/${patientId}/documents`
export const PATIENT_NOTES_TYPES = '/patients/note-types'
export const CONSENT_TEMPLATE_ROUTE = '/patients/consent-template'
export const PATIENT_ACTIVE_INSURANCE_ROUTE = '/patients/active-insurance'

export const getUserIdByEhrId = (ehrId: string): string =>
  `/patients/ehr/${ehrId}/user-id`

export const getFirstBookingStateRoute = (patientId: string): string =>
  `/patients/${patientId}/first-booking-state`
